export default __webpack_public_path__ + "static/media/image15.755b4770.png";